import { share } from "core/javascriptChannels";
import { useNotifyModalContext } from "shared/core/state/NotifyModalContext/NotifyModalContext";
import { useTranslation } from "react-i18next";
import Button from "shared/UI/Buttons/Button";

export const FileDownloader = ({ url, title }: { url: string; title: string }) => {
  const { t } = useTranslation(undefined, { keyPrefix: "resourceViewer.downloader" });
  const { modalNotify } = useNotifyModalContext();
  const isMobileApp = window.flutter_inappwebview != null;

  const downloadFile = () => {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
  };

  const shareFile = async () => {
    const shareSuccessful = await share(url, title);
    if (!shareSuccessful) {
      modalNotify("error", t("errorTitle"), t("error"), t("errorCta"));
    }
  };

  return (
    <div className="w-full lg:w-1/3 pt-12 left-0 m-auto">
      <Button text={isMobileApp ? t("shareDownload") : t("download")} onClick={async () => (isMobileApp ? shareFile() : downloadFile())} />
    </div>
  );
};
